type TemperatureOperator = "<" | "<=" | "===" | ">=" | ">";

function parseTemperatureValueString(inputStr: string): {
    operator: TemperatureOperator | "";
    value: string;
} {
    let str = inputStr;

    if (str.startsWith("X")) {
        str = str.substring(1);
    }

    const regex = /^(>=|<=|>|<|===)?(\d+)$/;
    const match = regex.exec(str);

    if (match?.[1] && match[2]) {
        return {
            operator: (match[1] as TemperatureOperator | undefined) ?? "",
            value: match[2]
        };
    }

    return {
        operator: "",
        value: ""
    };
}

export default parseTemperatureValueString;
